import { useReadContract } from "wagmi";

import { contractConfig } from "@config/contractsConfig";
import { mainnet } from "viem/chains";

export const useElMerkleProofIndex = () => {
  const mainnetConfig = contractConfig[mainnet.id];

  const { data: currentIndex } = useReadContract({
    ...mainnetConfig.interactionPools.merkleDistributor,
    functionName: "currentMerkleRootIndex",
    chainId: mainnet.id,
  });

  return currentIndex && Number(currentIndex);
};
